const UNAUTHORIZED = 401;

export default {
	UNAUTHORIZED
};



// WEBPACK FOOTER //
// ./src/utils/status-codes.js